module.exports = __webpack_public_path__ + "static/media/maintenance_icon.6106ec80.png";